import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';

export default class Customers extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: ''
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    async refreshData(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.setState({ loading: true });

        this.httpPost("api/v1/customer/list", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.setState({
                    loading: false
                });
            }
        })
    }
    handlePageChange(page) {
        this.state.page = page;
        this.refreshData();
    }
    handlePerRowsChange(newPerPage) {
        this.state.page = 1;
        this.state.per_page = newPerPage;
        this.refreshData();
    }
    confirmRemove(record) {
        this.setState({
            id_to_remove: record
        });
    }
    remove() {
        this.httpPost("api/v1/customer/remove", {
            id: this.state.id_to_remove
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                this.setState({
                    id_to_remove: null
                });
                this.refreshData()
            }
            else
                this.showErorrMessage(data.message);
        })
        .catch(err => {
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });
    }
    renderForm() {
        return (
            <div>
                {!this.isBlank(this.state.id_to_remove) &&
                    <div className="modalBg">
                        <div className="modalInner">
                            <p>آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                            <button className="btn btn-danger" onClick={e => { this.remove(); }}>بله</button>
                            <button className="btn btn-primary mr-r-10" onClick={e => { this.setState({ id_to_remove: null }); }}>انصراف</button>
                        </div>
                    </div>
                }
                <div style={{"margin-bottom": "10px"}}>
                    <NavLink to="/customer/new" title="افزودن" style={{"margin-left": "10px"}}><img src="/assets/img/new_customer.png" /> افزودن شخص / مشتری</NavLink>
                </div>
                <form onSubmit={e => this.refreshData(e)} method="post" className='searchBox'>
                    <div>
                        <input type="text" className="form-control" placeholder="عبارت مورد نظر برای جستجو" onChange={e => this.state.phrase = e.target.value} defaultValue={this.state.phrase} />
                        <button type="submit"><img src="/assets/img/search.png" /></button>
                    </div>
                </form>
                {this.state.data.records.length > 0 ?
                    <table className='table table-striped' aria-labelledby="tabelLabel" style={{ "margin-top": "25px" }}>
                        <thead>
                            <tr>
                                <th>نام</th>
                                <th className="text-center">موبایل</th>
                                <th className="text-center">تعداد شرکت</th>
                                <th className="text-center">تعداد کاربر</th>
                                <th className="text-center">سریال برنامه</th>                                
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.records.map(record =>
                                <tr key={record.id}>
                                    <td>{record.name}</td>
                                    <td className="text-center">{record.mobile}</td>
                                    <td className="text-center">{record.company_count}</td>
                                    <td className="text-center">{record.user_count}</td>
                                    <td className="text-center">{record.software_number}</td>
                                    <td>
                                        <NavLink to={"/customer/edit/" + record.id} title="ویرایش"><img src="/assets/img/edit.png" /></NavLink>
                                        <a className="hand" onClick={e => this.confirmRemove(record.id)} title="حذف"><img src="/assets/img/trash.png" /></a>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                :
                    <p className="emptyRecords">شما هنوز هیچ شخص و مشتری ثبت نکرده اید</p>
                }
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {this.getToastContainer()}
                {contents}
            </div>
        );
    }
}